
























import { Component, Prop, mixins, Watch } from 'nuxt-property-decorator'
import { LotInfo, Salesperson } from '~/models';
import { getSalespeople } from '~/api/salesperson.api'
import globalStyling from '~/mixins/globalStyling'

@Component({})
export default class  extends mixins(globalStyling) {
  // The lotId is separated from the lotInfo to allow the component to correctly
  // watch the id and update as it changes.
  @Prop({default: null}) lotId: number
  @Prop({default: null}) lotInfo: LotInfo
  @Prop({default: null}) lotType: 'plan' | 'lot'

  salespeople: Array<Salesperson> = []

  async mounted() {
    this.onChangeLotId(this.lotInfo, this.lotType)
  }

  @Watch('lotId')
  async onChangeLotId(lotInfo: LotInfo, type: 'plan' | 'lot') {
    if (lotInfo?.id && type) {
      try {
        this.salespeople = await getSalespeople(lotInfo.id, type)
      } catch (err) {
        console.error("There was a problem retrieving sales person data.")
      }
    }
  }

  emailLink(email: string) {
    let subject = `Information request: `
    let body = `I am interested in `
    if (this.lotType === 'lot') {
      subject += `${this.lotInfo.title}`
      body += `${this.lotInfo.title}, ${this.lotInfo.city}, ${this.lotInfo.state}  ${this.lotInfo.postal_code}. Let's get started!`
    }
    if (this.lotType === 'plan') {
      subject += `${this.lotInfo.name}`
      body += `the ${this.lotInfo.name} home plan. Let's get started!`
    }
    return `mailto:${email}?subject=${subject}&body=${body}`
  }
}
